import React from 'react'
import { Route, Switch } from 'react-router-dom'
import Loadable from './Loadable'

const AsyncNotFound = Loadable({
    loader: () => import(/* webpackChunkName: "NotFound" */ 'Features/ui/components/NotFound')
})

const AsyncLogin = Loadable({
    loader: () => import('../../user/components/Login')
})

//New
const AsyncSearchRoomBasic = Loadable({
    loader: () => import('../../rooms/components/pages/SearchRoomBasic')
})

const AsyncSearchRoomAdvance = Loadable({
    loader: () => import('../../rooms/components/pages/SearchRoomAdvance')
})

const AsyncRoomSlots = Loadable({
    loader: () => import('../../rooms/components/pages/RoomSlots')
})

const AsyncCreateEvent = Loadable({
    loader: () => import('../../events/components/pages/CreateEvent')
})

const AsyncCreateEventTrainingNew = Loadable({
    loader: () => import('../../events/components/pages/CreateEventTraining')
})

const AsyncCreateEventSuccessNew = Loadable({
    loader: () => import('../../events/components/pages/CreateEventSuccess')
})

const AsyncEventStatus = Loadable({
    loader: () => import('../../events/components/pages/CheckInEventSuccess')
})

const AsyncEditEventNew = Loadable({
    loader: () => import('../../events/components/pages/EditEvent')
})

const AsyncEditEventTrainingNew = Loadable({
    loader: () => import('../../events/components/pages/EditEventTraining')
})

const AsyncEditEventSuccessNew = Loadable({
    loader: () => import('../../events/components/pages/EditEventSuccess')
})

const AsyncEventDetail = Loadable({
    loader: () => import('../../events/components/pages/EventDetail')
})

const AsyncMyMeetingComing = Loadable({
    loader: () => import('../../mybookings/components/pages/MyMeetingComing')
})

const AsyncMyMeetingHistory = Loadable({
    loader: () => import('../../mybookings/components/pages/MyMeetingHistory')
})

const AsyncMyMeetingCalendar = Loadable({
    loader: () => import('../../mybookings/components/pages/MyMeetingCalendar')
})

const AsyncScanQrcodeCheckin = Loadable({
    loader: () => import('../../qrcode/components/pages/ScanQrcodeCheckin')
})

const AsyncScanQrcodeRoom = Loadable({
    loader: () => import('../../qrcode/components/pages/ScanQrcodeRoom')
})

const AsyncUserInformation = Loadable({
    loader: () => import('../../user/components/pages/UserInformation')
})

const AsyncTermAndConditionNew = Loadable({
    loader: () => import('../../user/components/pages/TermAndCondition')
})

const AsyncFirstChangePassword = Loadable({
    loader: () => import('../../user/components/FirstChangePassword')
})

const AsyncLocation = Loadable({
    loader: () => import('../../user/components/pages/UserLocation')
})

const AsyncChangePassword = Loadable({
    loader: () => import('../../user/components/ChangePassword')
})

const AsyncRoomService = Loadable({
    loader: () => import('../../roomService/components/Upcoming')
})

const x = Loadable({
    loader: () => import('../../ui/components/X')
})

export default () => (
    <Switch>
        <Route path='/login' component={AsyncLogin} />
        <Route path='/viewterm' component={AsyncTermAndConditionNew} />
        <Route path='/term' component={AsyncTermAndConditionNew} />
        <Route path='/userinfo' component={AsyncUserInformation} />
        <Route path='/search/:text' component={AsyncSearchRoomBasic} />
        <Route path='/home' component={AsyncSearchRoomBasic} />
        <Route path='/searchAdvance/' component={AsyncSearchRoomAdvance} />
        <Route path='/roomSlots/:path/:id/:date/:start/:end' component={AsyncRoomSlots} />
        <Route path='/roomSlots/:path/:id' component={AsyncRoomSlots} />
        <Route path='/myreservationHistory' component={AsyncMyMeetingHistory} />
        <Route path='/myreservationComing' component={AsyncMyMeetingComing} />
        <Route path='/myreservationDay' component={AsyncMyMeetingCalendar} />
        <Route path='/createEvent/:path/:id/:single/:startDate/:endDate/:startTime/:endTime' component={AsyncCreateEvent} />
        <Route path='/createEvent/:path/:id' component={AsyncCreateEvent} />
        <Route path='/createEventTraining/:path/:id/:single/:startDate/:endDate/:startTime/:endTime' component={AsyncCreateEventTrainingNew} />
        <Route path='/createEventTraining/:path/:id' component={AsyncCreateEventTrainingNew} />
        <Route path='/createEventSuccess/:eventid' component={AsyncCreateEventSuccessNew} />
        <Route path='/editEvent/:type/:id' component={AsyncEditEventNew} />
        <Route path='/editEventTraining/:type/:id' component={AsyncEditEventTrainingNew} />
        <Route path='/editEventSuccess/:eventid' component={AsyncEditEventSuccessNew} />
        <Route path='/eventDetail/:eventid' component={AsyncEventDetail} />
        <Route path='/checkinConfirm/:id' component={AsyncEventStatus} />
        <Route path='/checkIn/:roomid/:eventid' component={AsyncScanQrcodeCheckin} />
        <Route path='/qrcode' component={AsyncScanQrcodeRoom} />
        <Route path='/userlocation' component={AsyncLocation} />
        <Route path='/x' component={x} />
        <Route path='/reset/:email' component={AsyncChangePassword} />
        <Route path='/changepassword/:id' component={AsyncFirstChangePassword} />

        <Route path='/roomservices' component={AsyncRoomService} />
        <Route path='/' component={AsyncSearchRoomBasic} />
        <Route component={AsyncNotFound} />
    </Switch>
)


// WEBPACK FOOTER //
// ./src/front/features/ui/components/Routes.js